export const ganaPointsConstants = {
  GANA_POINTS_REQUEST: 'GANA_POINTS_REQUEST',
  GANA_POINTS_SUCCESS: 'GANA_POINTS_SUCCESS',
  GANA_POINTS_FAILURE: 'GANA_POINTS_FAILURE',
  USER_POINTS_REQUEST: 'USER_POINTS_REQUEST',
  USER_POINTS_SUCCESS: 'USER_POINTS_SUCCESS',
  USER_POINTS_FAILURE: 'USER_POINTS_FAILURE'
};
